import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filterData: {
    crewID: null,
    vessel: null,
    vendor: null,
    poStatus: 4,
    poInitiator: null,
    invoiceStatus: null,
    vesselOwner: null,
    budgetCategory: null,
    todate: null,
    fromdate: null,
    search: null,
    shortCloseStatus: null,
    plannedVesselRevisionId: null,
    serviceFromDate: null,
    serviceToDate: null,
    expenseCategoryId: null,
    expenseCategoryName: null
  }
};

const fliterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    updateFliter: (state, action) => {
      state.filterData = action.payload;
    },
    resetFilter: () => initialState
  }
});

export default fliterSlice.reducer;
export const { updateFliter, resetFilter } = fliterSlice.actions;
